<template>
  <span class="relative flex h-2 w-2">
    <span
      class="absolute inline-flex h-full w-full animate-ping rounded-full bg-main-primary/90 opacity-75"
    />
    <span
      class="absolute inline-flex h-full w-full animate-ping rounded-full bg-main-primary/80 opacity-75"
    />
    <span
      class="relative inline-flex h-2 w-2 rounded-full bg-main-primary"
    />
  </span>
</template>

<script>
export default {
  name: 'AnimatedPing',
}
</script>
